import React, { useEffect, useRef } from 'react';
import { Button } from '@material-tailwind/react';

import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { setImgObj, setFormData, setChildFormData } from '../../reducers/contextSlice';
import { useDispatch } from 'react-redux';

export const FileInput = ({ id, accept, name, previewFields, imgClass, required = true, isChildModal = false, isImage, disabled = false, width = 128, height = 128, validateSize = false, acceptedExtensions }) => {

    const dispatch = useDispatch()
    const { imgObj, childFormData, formData, addEditDeleteTag } = useSelector(state => state.context)

    const wrapperRef = useRef(null);
    const onDragEnter = () => wrapperRef.current.classList.add('dragover');
    const onDragLeave = () => wrapperRef.current.classList.remove('dragover');
    const onDrop = () => wrapperRef.current.classList.remove('dragover');

    const fileRemove = (_ele, name) => {
        dispatch(setFormData({ ...formData, [_ele]: undefined }));
        dispatch(setImgObj({
            ...imgObj,
            [name]: undefined,
            [_ele]: undefined,
        }));
    }

    const onFileChange = (e) => {
        const fileObject = e.target.files[0];
        if (!fileObject || !fileObject.name.match(acceptedExtensions)) {
            return toast.error('Please select valid image.');
        } else {
            const reader = new FileReader();
            reader.readAsDataURL(fileObject);
            reader.onload = function (_e) {
                const image = new Image();
                const imageContent = reader.result;
                const decodedString = atob(imageContent.split(',')[1]);
                image.src = imageContent.split(',')[0] + ',' + btoa(decodedString);
                image.onerror = function () {
                    return toast.error('Please select valid image.');
                };
                image.onload = function () {
                    const isSVG = fileObject.type === 'image/svg+xml';
                    const imgHeight = this.height
                    const imgWidth = this.width;
                    if (isSVG) {
                        const svgReader = new FileReader();
                        svgReader.onload = function (e) {
                            const svgContent = e.target.result;
                            const tempSvg = new Blob([svgContent], { type: 'image/svg+xml' });
                            const url = URL.createObjectURL(tempSvg);
                            const tempImg = new Image();
                            tempImg.onload = function () {
                                const svgImgHeight = tempImg.height;
                                const svgImgWidth = tempImg.width;
                                handleDimensionsCheck(imgWidth, imgHeight, isSVG, svgImgWidth, svgImgHeight);
                            };
                            tempImg.src = url;
                        };
                        svgReader.readAsText(fileObject);
                    } else {
                        handleDimensionsCheck(imgWidth, imgHeight, isSVG, null, null);
                    }
                };
            };

            function handleDimensionsCheck(imgWidth, imgHeight, isSVG, svgImgWidth, svgImgHeight) {
                const tolerance = 50;
                if (validateSize) {
                    if (isSVG) {
                        if (svgImgWidth !== width || svgImgHeight !== height) {
                            return toast.error(`Width and Height size must be ${width}x${height} for SVG files.`);
                        }
                    } else {
                        if (
                            (imgWidth < width - tolerance || imgWidth > width + tolerance) ||
                            (imgHeight < height - tolerance || imgHeight > height + tolerance)
                        ) {
                            return toast.error(`Width and Height size must be approximately ${width}x${height}.`);
                        }
                    }
                }

                dispatch(setFormData({ ...formData, [e.target.name]: fileObject }));

                dispatch(setImgObj({
                    ...imgObj,
                    [e.target.name]: URL.createObjectURL(fileObject)
                }));
            }
        }
    }

    const fileChildRemove = (_ele, name) => {
        dispatch(setChildFormData({ ...childFormData, [_ele]: undefined }));
        dispatch(setImgObj({ ...imgObj, [name]: undefined, [_ele]: undefined }));
    }
    const onChildFileChange = (e) => {
        const fileObject = e.target.files[0];
        if (!fileObject.name.match(/\.(jpg|jpeg|png|gif|webp)$/)) {
            return toast.error('Please select valid image.');
        } else {
            const reader = new FileReader();
            reader.readAsDataURL(fileObject);
            reader.onload = function (_e) {
                const image = new Image();
                const imageContent = reader.result;
                const decodedString = atob(imageContent.split(',')[1]);
                image.src = imageContent.split(',')[0] + ',' + btoa(decodedString);
                image.onerror = function () {
                    return toast.error('Please select valid image.');
                };
                image.onload = function () {
                    const imgHeight = this.height
                    const imgWidth = this.width;
                    if ((imgWidth > width || imgHeight > height) && validateSize) {
                        return toast.error(`Width and Height size must be ${width}x${height}.`);
                    } else {
                        dispatch(setChildFormData({ ...childFormData, [e.target.name]: fileObject }));

                        dispatch(setImgObj({ ...imgObj, [e.target.name]: URL.createObjectURL(fileObject) }));
                    }
                };
            };
        }
    }

    const previewUrl = formData[previewFields] || childFormData[previewFields];

    useEffect(() => {
        if (previewUrl && typeof previewUrl === 'string') {
            dispatch(setImgObj({ [previewFields]: previewUrl }));
        }
    }, [previewFields, previewUrl, dispatch]);


    return (
        <>
            {
                (imgObj[name] || imgObj[previewFields]) ?
                    <div className='file-preview rounded-[10px] h-auto relative border-2 border-dashed border-[#CCCCCC]'>
                        <img src={imgObj[name] ? imgObj[name] : `${imgObj[previewFields]}`} alt={formData?.name || childFormData?.name} className={`w-auto p-1 rounded-[10px] ${imgClass}`} />
                        {addEditDeleteTag !== 'view' && <Button variant='filled' className="file-remove-icon !absolute m-auto rounded-full top-2.5 right-2.5 leading-normal py-1.5 px-3 bg-danger shadow-none hover:shadow-none " onClick={() => { isChildModal ? fileChildRemove(previewFields, name) : fileRemove(previewFields, name); }}>Remove</Button>}
                    </div>
                    :
                    <div
                        ref={wrapperRef}
                        className={`drop-file-input rounded-[10px] h-[241px] relative flex items-center justify-center py-10 hover:opacity-[0.6] border-2 border-dashed border-[#CCCCCC] break-words p-2`}
                        onDragEnter={onDragEnter}
                        onDragLeave={onDragLeave}
                        onDrop={onDrop}
                    >
                        <p className='text-sm leading-none font-semibold'><span className='text-purple'>Click to upload photo</span> or drag and drop</p>
                        <input id={id} accept={accept} name={name} type="file" onChange={isChildModal ? onChildFileChange : onFileChange} className='absolute w-full h-full cursor-pointer opacity-0 top-0 left-0 ' required={required} disabled={disabled} />
                    </div>
            }
        </>
    );
}

export default FileInput;